import * as ActionTypes from "./actionTypes";

export function controlPanelInit() {
	return { type: ActionTypes.CONTROL_PANEL_INIT };
}

export function controlPanelInitComplete() {
	return { type: ActionTypes.CONTROL_PANEL_INIT_COMPLETE };
}

export function log(options) {
	return { type: ActionTypes.LOG, options };
}

export function displayError(message) {
	return { type: ActionTypes.DISPLAY_ERROR, message };
}

export function displayQuickMessage(message, status = "success", icon = null) {
	return { type: ActionTypes.DISPLAY_QUICK_MESSAGE, message, status, icon };
}
export function removeQuickMessage(id) {
	return { type: ActionTypes.REMOVE_QUICK_MESSAGE, id };
}

export function loadMetadata() {
	return { type: ActionTypes.LOAD_METADATA };
}

export function loadTimezonesSuccess(data) {
	return { type: ActionTypes.LOAD_TIMEZONES_SUCCESS, data };
}

export function loadTimezonesFail(error) {
	return { type: ActionTypes.LOAD_TIMEZONES_FAIL, error };
}

export function showLoading() {
	return { type: ActionTypes.SHOW_LOADING };
}

export function hideLoading() {
	return { type: ActionTypes.HIDE_LOADING };
}

export function toggleAppPreview() {
	return { type: ActionTypes.TOGGLE_APP_PREVIEW };
}
